import SettingsNavigator from './SettingsNavigator';
export default SettingsNavigator;